// Module
var code = "\n<ul class=\"{{ form.htmlClass }}\">\n  <li class=\"{{ item.htmlClass }}\" ng-repeat=\"item in form.items\">{{ item.title }}</li>\n</ul>";
// Exports
export default code;